import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    {
      value: 0,
      label: 'Goals',
      singularLabel: 'goal',
      priority: 4,
      colour: '#55578d',
      textColour: '#FFFFFF',
      class: 'hero-purple',
      schoolCanEdit: true,
      jurisdiction: 'All',
      hasContent: true,
      description:
        'No type has been set for this content, you can set the content type by editing each subject.',
    },
    {
      value: 1,
      label: 'Goals',
      singularLabel: 'goal',
      priority: 4,
      jurisdiction: 'All',
      class: 'hero-light-blue',
      colour: '#76B9F0',
      textColour: '#FFFFFF',
      schoolCanEdit: true,
      hasContent: true,
      description:
        'Goals are small content steps that help students work towards a larger outcome.',
    },
    {
      value: 2,
      label: 'Outcomes',
      singularLabel: 'outcome',
      priority: 1,
      jurisdiction: 'AU NSW',
      class: 'hero-blue',
      colour: '#01667d',
      textColour: '#FFFFFF',
      schoolCanEdit: false,
      hasContent: true,
      description:
        'Outcomes are licenced by the New South Wales Education Standards Authority (NESA) and so cannot be edited. If you believe that there is an error with these outcomes, please contact Hero support.',
    },
    {
      value: 3,
      label: 'Objectives',
      singularLabel: 'objective',
      priority: 2,
      colour: '#FF8210',
      class: 'hero-orange',
      jurisdiction: 'All',
      textColour: '#FFFFFF',
      schoolCanEdit: true,
      hasContent: true,
      description:
        'Objectives are broader milestones that guide students’ learning pathways toward curricular goals.',
    },
    {
      value: 4,
      label: 'Content',
      singularLabel: 'content',
      priority: 2,
      colour: '#1FA6A6',
      class: 'hero-teal',
      textColour: '#FFFFFF',
      jurisdiction: 'AU NSW',
      schoolCanEdit: true,
      hasContent: true,
      description:
        'Core content aligned with the NSW curriculum, licenced by the New South Wales Education Standards Authority (NESA), outlining the knowledge and skills students are expected to acquire at each stage.',
    },
    {
      value: 5,
      label: 'Progressions',
      singularLabel: 'progression',
      colour: '#FF8210',
      class: 'hero-orange',
      priority: 3,
      textColour: '#000000',
      jurisdiction: 'AU NSW',
      schoolCanEdit: true,
      hasContent: true,
      description:
        'Progressions outline the incremental stages of student learning, providing a framework for assessing ongoing development against the NSW curriculum standards.',
    },
    {
      value: 6,
      label: 'Early Years',
      singularLabel: 'early years content',
      priority: 1,
      colour: '#ffcd9f',
      class: 'hero-orange',
      textColour: '#FFFFFF',
      schoolCanEdit: true,
      jurisdiction: 'UK',
      hasContent: true,
      description:
        'The Early Years curriculum provides a framework for foundational learning and development, covering the core areas for children in their earliest stages of learning.',
    },
    {
      value: 7,
      label: 'NZC Scope/Sequence',
      singularLabel: 'scope',
      priority: 1,
      class: 'hero-blue',
      colour: '#01667d',
      textColour: '#FFFFFF',
      jurisdiction: 'NZ MOE',
      schoolCanEdit: false,
      hasContent: true,
      description:
        'This content comes directly from the NZ curriculum and so cannot be edited. If you believe that there is an error with these outcomes, please contact Hero support.',
    },
    {
      value: 8,
      label: 'National Curriculum',
      singularLabel: 'content',
      class: 'hero-blue',
      priority: 1,
      colour: '#01667d',
      textColour: '#FFFFFF',
      jurisdiction: 'UK',
      schoolCanEdit: false,
      hasContent: true,
      description:
        'This content comes directly from the national curriculum for England to be taught in all local-authority-maintained schools and so cannot be edited. If you believe that there is an error with these outcomes, please contact Hero support.',
    },
    {
      value: 9,
      label: 'Local Curriculum',
      singularLabel: 'curriculum content',
      priority: 4,
      colour: '#1FA6A6',
      class: 'hero-teal',
      textColour: '#000000',
      jurisdiction: 'All',
      schoolCanEdit: true,
      hasContent: true,
      description:
        'The local curriculum allows schools to tailor learning experiences to their community needs.',
    },
    {
      value: 10,
      label: 'Programme Content',
      singularLabel: 'programme content',
      colour: '#55578D',
      class: 'hero-purple',
      priority: 2,
      textColour: '#FFFFFF',
      jurisdiction: 'All',
      schoolCanEdit: false,
      hasContent: true,
      description:
        'A third-party provider has provided this content to support a structured teaching approach.',
    },
    {
      value: 11,
      label: 'Opportunities',
      singularLabel: 'opportunity',
      priority: 4,
      colour: '#FCB421',
      textColour: '#FFFFFF',
      class: 'hero-orange',
      jurisdiction: 'All',
      schoolCanEdit: false,
      hasContent: true,
      description:
        'Opportunities are varied activities and roles that enable students to explore and contribute beyond core learning pathways.',
    },
    {
      value: 12,
      label: 'TMoA',
      singularLabel: 'TMoA content',
      priority: 1,
      colour: '#29741D',
      class: 'hero-dark-green',
      textColour: '#FFFFFF',
      jurisdiction: 'NZ MOE',
      schoolCanEdit: false,
      hasContent: true,
      description:
        'Kua tauākītia tēnei kōrero i te marautanga o Aotearoa, ā, kāore e taea te whakatika. Mēnā kei te whakapono koe he hē kei ēnei putanga, tēnā whakapā atu ki te tautoko a Hero.',
    },
    {
      value: 13,
      label: 'Progress',
      singularLabel: 'progress',
      priority: 4,
      colour: '#29741d',
      textColour: '#FFFFFF',
      class: 'hero-dark-green',
      jurisdiction: 'All',
      schoolCanEdit: false,
      hasContent: false,
      description:
        'This subject is designed to be used for recording and displaying progress, It does not have any content.',
    },
  ],
});
